var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-control-button block text-xs"},[_c('button',{staticClass:"px-1 py-0",on:{"click":function($event){return _vm.toggleBodyClass('addClass', 'logo-upload')}}},[_vm._v("Upload Logo")])])}
var staticRenderFns = []

export { render, staticRenderFns }